export enum ValidationItemStatus {
  VALIDATED = 'validated',
  WARNING = 'warning',
  CRITICAL = 'critical',
}

export enum ValidationItemAction {
  PENDING = 'pending',
  DISMISSED = 'dismissed',
  APPLIED = 'applied',
  IGNORED = 'ignored',
}

export enum ValidationJobStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}